import { useEffect, useState } from 'react';
import { InputAdornment, Paper } from '@mui/material';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import TDSChequeList from 'components/SS/TDSChequeList';
import AddPayment from 'components/SS/addPayment';
import IconifyIcon from 'components/base/IconifyIcon';
import StyledTextField from 'components/styled/StyledTextField';

const TDS = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
    search: search,
  });
  const [total, setTotal] = useState(0);
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, search }));
  }, [search]);

  const fetchData = async () => {
    try {
      setPayment([]);
      const response = await post('/users/payment', {
        modeOfPayment: 'TDS',
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        search: paginationModel.search,
      });
      if (response.status == 200) {
        setData(response.data.data);
        setTotal(response.data.total);
      } else {
        enqueueSnackbar('failed to fetched customer payments!', {
          variant: 'error',
          autoHideDuration: 3000,
        });
        setData([]);
        setTotal(0);
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error', { variant: 'error', autoHideDuration: 3000 });
      setData([]);
      setTotal(0);
    }
  };
  useEffect(() => {
    fetchData();
  }, [paginationModel]);

  // const data = [
  //   {
  //     id: 1,
  //     name: 'Rahul Sharma',
  //     avatar: 'https://i.pravatar.cc/40?img=1',
  //     email: 'rahul.sharma@example.com',
  //     City: { name: 'Ahmedabad' },
  //     dateOfEnquiry: '2025-10-08',
  //     sourceOfEnquiry: 'Google Ads',
  //     Requirement: 5,
  //     offerAccepted: true,
  //     geda: {
  //       uploaded: 'yes',
  //       approved: null,
  //       report: 'awaiting',
  //       meter: 'no',
  //     },
  //     installationDone: true,
  //     installationCheckList: {
  //       meterFilePrepared: 'yes',
  //       isMeterInstalled: 'no',
  //     },
  //     checkList: {
  //       fileHandOver: 'yes',
  //       subsidyFiled: 'no',
  //       subsidyreceived: 'no',
  //       siteReview: 'yes',
  //     },
  //     dispatch: {
  //       status: 'inProgress',
  //       material: [
  //         { type: 'partial', material: [], date: '07/10/2025' },
  //         { type: 'partial', material: [], date: '09/10/2025' },
  //       ],
  //     },
  //   },
  //   {
  //     id: 2,
  //     name: 'Priya Patel',
  //     avatar: 'https://i.pravatar.cc/40?img=2',
  //     email: 'priya.patel@example.com',
  //     City: { name: 'Surat' },
  //     dateOfEnquiry: '2025-09-25',
  //     sourceOfEnquiry: 'Referral',
  //     Requirement: 10,
  //     offerAccepted: true,
  //     geda: {
  //       uploaded: 'yes',
  //       approved: 'yes',
  //       report: 'awaiting',
  //       meter: 'no',
  //     },
  //     installationDone: true,
  //     installationCheckList: {
  //       meterFilePrepared: 'yes',
  //       isMeterInstalled: 'yes',
  //     },
  //     checkList: {
  //       fileHandOver: 'yes',
  //       subsidyFiled: 'no',
  //       subsidyreceived: 'no',
  //       siteReview: 'yes',
  //     },
  //     dispatch: {
  //       status: 'hold',
  //       material: [
  //         { type: 'partial', material: [], date: '07/10/2025' },
  //         { type: 'full', material: [], date: '09/10/2025' },
  //       ],
  //     },
  //   },
  //   {
  //     id: 3,
  //     name: 'Amit Mehta',
  //     avatar: 'https://i.pravatar.cc/40?img=3',
  //     email: 'amit.mehta@example.com',
  //     City: { name: 'Rajkot' },
  //     dateOfEnquiry: '2025-10-05',
  //     sourceOfEnquiry: 'Direct Visit',
  //     Requirement: 7,
  //     offerAccepted: true,
  //     geda: {
  //       uploaded: 'yes',
  //       approved: null,
  //       report: 'awaiting',
  //       meter: 'no',
  //     },
  //     installationDone: true,
  //     installationCheckList: {
  //       meterFilePrepared: 'yes',
  //       isMeterInstalled: 'no',
  //     },
  //     checkList: {
  //       fileHandOver: 'yes',
  //       subsidyFiled: 'no',
  //       subsidyreceived: 'no',
  //       siteReview: 'yes',
  //     },
  //     dispatch: {
  //       status: 'dispatched',
  //       material: [
  //         { type: 'partial', material: [], date: '07/10/2025' },
  //         { type: 'full', material: [], date: '09/10/2025' },
  //       ],
  //     },
  //   },
  //   {
  //     id: 4,
  //     name: 'Neha Desai',
  //     avatar: 'https://i.pravatar.cc/40?img=4',
  //     email: 'neha.desai@example.com',
  //     City: { name: 'Vadodara' },
  //     dateOfEnquiry: '2025-09-30',
  //     sourceOfEnquiry: 'Website',
  //     Requirement: 8,
  //     offerAccepted: true,
  //     geda: {
  //       uploaded: null,
  //       approved: null,
  //       report: 'awaiting',
  //       meter: 'no',
  //     },
  //     installationDone: true,
  //     installationCheckList: {
  //       meterFilePrepared: 'yes',
  //       isMeterInstalled: 'no',
  //     },
  //     checkList: {
  //       fileHandOver: 'yes',
  //       subsidyFiled: 'no',
  //       subsidyreceived: 'no',
  //       siteReview: 'yes',
  //     },
  //     dispatch: {
  //       status: 'hold',
  //       material: [
  //         { type: 'partial', material: [], date: '07/10/2025' },
  //         { type: 'full', material: [], date: '09/10/2025' },
  //       ],
  //     },
  //   },
  //   {
  //     id: 5,
  //     name: 'Karan Joshi',
  //     avatar: 'https://i.pravatar.cc/40?img=5',
  //     email: 'karan.joshi@example.com',
  //     City: { name: 'Bhavnagar' },
  //     dateOfEnquiry: '2025-10-01',
  //     sourceOfEnquiry: 'LinkedIn',
  //     Requirement: 6,
  //     offerAccepted: true,
  //     geda: {
  //       uploaded: 'yes',
  //       approved: null,
  //       report: 'awaiting',
  //       meter: 'no',
  //     },
  //     installationDone: true,
  //     installationCheckList: {
  //       meterFilePrepared: 'no',
  //       isMeterInstalled: 'no',
  //     },
  //     checkList: {
  //       fileHandOver: 'yes',
  //       subsidyFiled: 'no',
  //       subsidyreceived: 'no',
  //       siteReview: 'yes',
  //     },
  //     dispatch: {
  //       status: 'hold',
  //       material: [
  //         { type: 'partial', material: [], date: '07/10/2025' },
  //         { type: 'full', material: [], date: '09/10/2025' },
  //       ],
  //     },
  //   },
  //   {
  //     id: 6,
  //     name: 'Sneha Shah',
  //     avatar: 'https://i.pravatar.cc/40?img=6',
  //     email: 'sneha.shah@example.com',
  //     City: { name: 'Gandhinagar' },
  //     dateOfEnquiry: '2025-09-20',
  //     sourceOfEnquiry: 'Google Maps',
  //     Requirement: 9,
  //     offerAccepted: true,
  //     geda: {
  //       uploaded: 'yes',
  //       approved: null,
  //       report: 'awaiting',
  //       meter: 'hold',
  //     },
  //     installationDone: true,
  //     installationCheckList: {
  //       meterFilePrepared: 'yes',
  //       isMeterInstalled: 'yes',
  //     },
  //     checkList: {
  //       fileHandOver: 'yes',
  //       subsidyFiled: 'no',
  //       subsidyreceived: 'no',
  //       siteReview: 'yes',
  //     },
  //     dispatch: {
  //       status: 'hold',
  //       material: [
  //         { type: 'partial', material: [], date: '07/10/2025' },
  //         { type: 'full', material: [], date: '09/10/2025' },
  //       ],
  //     },
  //   },
  // ];
  return (
    <>
      <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}>
        <StyledTextField
          id="search-box"
          type="search"
          fullWidth
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search Cheque"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <IconifyIcon icon="material-symbols:search-rounded" fontSize={20} />
                </InputAdornment>
              ),
            },
          }}
          sx={{
            maxWidth: { sm: 200, md: 240 },
            flexGrow: { xs: 1, sm: 0 },
            mb: 3,
          }}
        />
        <TDSChequeList
          data={data}
          total={total}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          setPayment={setPayment}
          setOpen={setOpen}
        />
        <AddPayment
          open={open}
          setOpen={setOpen}
          payment={payment}
          fetch={fetchData}
          setPayment={setPayment}
        />
      </Paper>
    </>
  );
};

export default TDS;
